/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { LoadCarriers } from '../../models/load-carriers';
import { PutLoadCarrierRequest } from '../../models/put-load-carrier-request';

export interface PutConsigneeLoadCarriers$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The delivery note key
 */
  deliveryNoteKey: KeyType;
      body: PutLoadCarrierRequest
}

export function putConsigneeLoadCarriers(http: HttpClient, rootUrl: string, params: PutConsigneeLoadCarriers$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadCarriers>> {
  const rb = new RequestBuilder(rootUrl, putConsigneeLoadCarriers.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoadCarriers>;
    })
  );
}

putConsigneeLoadCarriers.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/load-carriers';
